import { PathHelperProvider } from '@/hooks/usePathHelper'
import { AdminBuildUpdateToast } from '@/components/admin/AdminBuildUpdateToast'
import { Toaster } from '@/components/ui/toast'
import { getAdminProductName } from '@/lib/brand'
import type { AdminRouterContext } from '@/lib/router-context'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import {
  createRootRouteWithContext,
  HeadContent,
  Outlet,
  Scripts,
  useRouterState,
} from '@tanstack/react-router'
// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

export const Route = createRootRouteWithContext<AdminRouterContext>()({
  head: () => ({
    meta: [{ title: getAdminProductName() }],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const routeHref = useRouterState({ select: (state) => state.location.href })

  return (
    <>
      <HeadContent />
      <PathHelperProvider>
        <Outlet />
      </PathHelperProvider>
      <AdminBuildUpdateToast routeHref={routeHref} />
      <Toaster />
      {/* <TanStackRouterDevtools position="bottom-left" /> */}
      {/* <ReactQueryDevtools /> */}
      <Scripts />
    </>
  )
}
